export class LocaleHelper {
	public static languageToLocale(language: string): string {
		switch (language) {
			case 'en':
				return 'en-US';
			case 'de':
			default:
				return 'de-DE';
		}
	}

	public static localeToLanguage(locale: string): string {
		switch (locale) {
			case 'en-US':
				return 'en';
			case 'de-DE':
			default:
				return 'de';
		}
	}
}
